import { CatalogSortFactory } from "./CatalogSortFactory";
import { AnonymousPageController } from "@modules/basic/page";
import { SortTypeDisplayValue } from "@modules/product/catalog-product/model/dto/SortTypeDisplayValue.enum";
import { ICatalogProductRestService, limitType } from '@modules/product/catalog-product/rest/catalog-product-rest';
import { SortType } from "@modules/product/catalog-product/model/dto/SortType.enum";
import type { CatalogProduct } from "@modules/product/catalog-product/model/dto/CatalogProduct";
import { CatalogObjectTree } from "./catalog-object-tree";
import { PromptTypeEnum } from "@modules/base/decorator/error/PromptType.enum";
import { envConfig } from "@env/env-config";
import { IAnonymousRestService } from "@modules/user/rest/anonymous-rest";
import { IMessageDialog } from "@qpUIs/qp-message-dialog/qp-message-dialog.interface";
import { IMessageDialogOptions } from "@qpUIs/qp-message-dialog/qp-message-dialog-options.interface";
import { IUserDataService } from "@modules/user/service/data/i-user-data-service";
import { productCatalogIframeUpdateCurrencyParams } from "@pages/personal-center/products/products-catalog.controller";
import is from "@core/comparators/is";
export class ProductsController extends AnonymousPageController {

    public static readonly $inject: Array<string> = ["$objectTree", "anonymousRestService", "eventBus", "$scope", "$window", "pageContext", "urlBuilder", "catalogProductRestService", "$q", "$timeout", "qpMessageDialog", "$translate", "$injector", "userDataService"];
    // 临时数据
    public sortTypedisplayArr = SortTypeDisplayValue;
    // 产品数据加载状态
    private productsLoading: boolean;
    // 文件地址前缀
    public fileRoot: string;
    // 根目录
    public rootPath: string;
    // 当前页码下的类目产品
    public products: any[] = [];
    // 页码
    public currentPage: number;
    // 分页限制
    public limit: number;
    // 排序类型
    public sortType: string;
    // 过滤条件
    // filter: string;
    // 产品总数量
    public totalCount: number;
    // 类目产品总数量
    public productsTotalCount: number;
    private TIMESORT = { "property": "createdDate", "direction": "DESC" };

    // 分类产品搜索条件
    private searchkeywords: string;
    /**
     * @desc 单个产品价格 初始化中
     */
    protected isProductPriceInitializing: boolean = false;

    constructor(private $objectTree: CatalogObjectTree, anonymousRestService: IAnonymousRestService, public eventBus: qpmn.common.tool.IEventBus, public $scope: angular.IScope, private $window: angular.IWindowService, public pageContext: qpmn.main.IPageContext, public urlBuilder: qpmn.common.rest.IUrlBuilderService, public catalogProductRestService: ICatalogProductRestService, public $q: angular.IQService, public $timeout: angular.ITimeoutService, public qpMessageDialog: IMessageDialog, public $translate: angular.translate.ITranslateService, public $injector: angular.auto.IInjectorService, public userDataService: IUserDataService) {
        super($objectTree, anonymousRestService);
        // 路由改变后,重置类目产品
        this.$scope.$on("$routeChangeSuccess", (event, currentRoute, preRoute) => {
            this.checkAuthorization(() => {
                // 产品类目不存在时，跳转默认类目
                if (!is.undefined(currentRoute) && !is.undefined(currentRoute.pathParams) && !is.undefined(currentRoute.pathParams.childCatalog) && !is.undefined(currentRoute.pathParams.parentCatalog)) {
                    // 子类目
                    const childCatalog = currentRoute.pathParams.childCatalog;
                    // 父类目
                    const parentCatalog = currentRoute.pathParams.parentCatalog;
                    // 产品类目路由地址
                    const routePath = `${parentCatalog}/${childCatalog}`;
                    // 根据产品类目路由地址，获取对应产品类目配置，产品类目配置存在当前产品类目路由地址合法，反之不合法
                    const catalogConfig = this.$objectTree.catalogPagePathMap?.get(routePath);
                    if (!is.undefined(catalogConfig)) {
                        // 产品类目路由地址-合法，更新当前产品类目配置
                        this.$objectTree.currentCatalog = catalogConfig;
                        // 更新页面标题
                        this.updatePageTitle(this.$objectTree.currentCatalog.pageTitle);
                        // 更新页面metaDescription
                        this.updatePageMetaDes(this.$objectTree.currentCatalog.metaDescription);
                        // 同步 canonical：客户端路由(pushState)切换类目后，<head> 不会重新解析，
                        // 首屏的 IIFE 不会再执行，需在此手动把 canonical 指向当前真实 URL
                        this.updateCanonical();
                        this.$objectTree.setUserDataService(this.userDataService);

                        // 排序类型
                        this.sortType = "PRIORITYSORT";
                        // 分页查询限制
                        this.limit = 12
                        // 初始化类目产品列表;
                        this.productsLoading = true;

                        this.$objectTree.userPreference.then(() => {
                            this.initCatalogProducts(this.$objectTree.currentCatalog!.id);
                        })
                    } else {
                        // 产品类目路由地址-合法，跳转默认产品类目
                        this.goDefaultCatalog();
                        return;
                    }
                } else {
                    // 产品类目路由地址-合法，跳转默认产品类目
                    this.goDefaultCatalog();
                    return;
                }
            });
        });

        this.fileRoot = envConfig.appPath("file");
        this.rootPath = pageContext.rootPath;
        // 设置产品属性搜索初始值
        this.searchkeywords = "";

        // 偏好修改后 重新请求
        const onCurrencyChangeByPostMessage = this.onCurrencyChangeByPostMessage.bind(this)
        if (window.self != window.top) {
            this.$window.addEventListener("message", onCurrencyChangeByPostMessage, false);
        }
        this.eventBus.addEventListener("UpdateCurrency", this.onCurrencyChange, this);
        this.$scope.$on("$destroy", () => {
            this.eventBus.removeEventListener("UpdateCurrency", this.onCurrencyChange, this);
            this.$window.removeEventListener("message", onCurrencyChangeByPostMessage, false);
        });
    }

    /**
     * @description 查询类目产品数据--路由切换初始化类目产品(page:1)
     * **/
    public initCatalogProducts(catalogId: number) {
        // 开启骨架屏加载动画
        this.productsLoading = true;
        // 获取分类产品查询页码
        let _page = 1;
        // 获取分类产品分页查询限制limit
        let _limit = this.limit;
        // 获取类目产品数据
        this.getCatalogProducts(_page, _limit, catalogId)
            .then(res => {
                this.products = res;
                // 更新分类产品查询页码
                this.currentPage = 1;
                //关闭骨架屏动画
                this.productsLoading = false;
            }, error => {
                //关闭骨架屏动画
                this.productsLoading = false;
                let that = this;
                this.onRequestFailed(error)
                    .then(e => {
                        // 通用错误处理
                        that.openUnhandleErrorMsgDialog();
                        that.sendError('catalog.products.sortProducts()', error);
                    })
            });
    }

    /**
     * @description 查询类目产品数据--分页加载更多，获取下一页类目产品数据
     * 
     * */
    public getMoreProducts() {
        // 开启骨架屏加载动画
        this.productsLoading = true;
        // 获取分类产品查询页码
        let _page = this.currentPage + 1;
        // 获取分类产品分页查询限制limit
        let _limit = this.limit;
        if (!this.$objectTree.currentCatalog || !this.$objectTree.currentCatalog.id) {
            this.goDefaultCatalog();
            //关闭骨架屏动画
            this.productsLoading = false;
            return;
        } else {
            // 获取类目产品数据
            this.getCatalogProducts(_page, _limit, this.$objectTree.currentCatalog.id)
                .then(res => {
                    this.products = this.products.concat(res);
                    // 更新分类产品查询页码
                    this.currentPage++;
                    //关闭骨架屏动画
                    this.productsLoading = false;
                }, error => {
                    //关闭骨架屏动画
                    this.productsLoading = false;
                    let that = this;
                    this.onRequestFailed(error)
                        .then(e => {
                            // 通用错误处理
                            that.openUnhandleErrorMsgDialog();
                            that.sendError('catalog.products.sortProducts()', error);
                        })
                });
        }
    }

    /**
     * @description 查询类目产品数据--根据制定排序规则查询类目产品
     * @param sortType 
     * */
    public sortProducts(sortType: string) {
        // 类目产品列表数据为空，无需进行类目产品查询
        if (this.products.length == 0) {
            return;
        }

        //开启骨架屏加载动画
        this.productsLoading = true;
        // 更新类目产品排序规则
        this.sortType = sortType;
        // 获取分类产品查询页码
        let _page = 1;
        // 获取分页查询限制limit
        let _limit = this.products.length ? this.products.length : 1;
        if (this.$objectTree.currentCatalog == undefined || this.$objectTree.currentCatalog.id == undefined || !this.$objectTree.currentCatalog.id) {
            this.goDefaultCatalog();
            return;
        } else {
            // 获取类目产品数据
            this.getCatalogProducts(_page, _limit, this.$objectTree.currentCatalog.id)
                .then(res => {
                    // 跟新类目产品数据
                    this.products = res;
                    //关闭骨架屏动画
                    this.productsLoading = false;
                }, error => {
                    //关闭骨架屏动画
                    this.productsLoading = false;
                    let that = this;
                    this.onRequestFailed(error)
                        .then(e => {
                            // 通用错误处理
                            that.openUnhandleErrorMsgDialog();
                            that.sendError('catalog.products.sortProducts()', error);
                        })
                });
        }
    }

    /**
     * @description 跳转产品分类页
     * @param productUrl 产品详情页地址路径
     * */
    public jumpProductDetail(productUrl: string) {
        if (!angular.isUndefined(this.$objectTree.urlParameter)) {
            this.$window.location.href = productUrl + this.$objectTree.urlParameter;
        } else {
            this.$window.location.href = productUrl;
        }
    }

    /**
     * @description 获取指定类目产品数据（filter、store、productCatalog已确定）
     * @param page :number 
     * @param limit :number
     * */
    public getCatalogProducts(page: number, limit: number, catalogId: number): angular.IPromise<Array<CatalogProduct>> {
        // 更新分类产品数据列表过滤条件filter
        let _filter = "";
        // 获取分类产品排序规则
        let sortFactory = new CatalogSortFactory();
        let _sort: Array<qpmn.main.model.IPageSort> = [];
        let _sorttype = sortFactory.creatSort(SortType[this.sortType]);
        _sort.push(_sorttype);
        _sort.push(this.TIMESORT);
        // console.log("_sort", _sort);

        // 创建promise
        let defered = this.$q.defer<Array<CatalogProduct>>();

        // 拼接请求参数
        const requestParams: limitType = { page: page, limit: limit, filter: _filter, sort: encodeURI(JSON.stringify(_sort)), catalogProductId: catalogId as number };
        if (this.$objectTree.appTag) {
            requestParams.appTag = this.$objectTree.appTag
        }
        if (this.$objectTree.appName) {
            requestParams.appName = this.$objectTree.appName;
        }

        this.catalogProductRestService.query(requestParams)
            .then(res => {
                if (res && res.data && res.data.totalCount) {
                    // 更新分类产品中数量(用于判断"more"加载更多按钮是否显示)
                    this.productsTotalCount = res.data.totalCount;
                    // 初始化产品详情页发布配置，.ejs--->.html
                    let productsData: Array<CatalogProduct> = res.data.content;
                    productsData.forEach(item => {
                        if (item.pageName) {
                            item.pageName = item.pageName.replace('.ejs', '.html');
                        } else {
                            const errorMsg = `productName:${item.name}, product Details CMS Release configuration Missing "pageName".`
                            this.sendError('catalog.product.getCatalogProducts()', errorMsg);
                        }

                        item.urlPath = this.rootPath + (this.rootPath.endsWith("/") ? "" : "/") + "products/" + item.pageName.replace('.html', '');


                        item.productImage.displayPath = `${this.fileRoot}/file/${item.productImage.name}?width=250&height=250`
                        if (item.hoverImage) {
                            item.productImage.displayPathHover = `${this.fileRoot}/file/${item.hoverImage.name}?width=250&height=250`

                        } else {
                            item.productImage.displayPathHover = `${this.fileRoot}/file/${item.productImage.name}?width=250&height=250`
                        }
                        item.isHover = false;

                    });
                    defered.resolve(productsData);
                } else {
                    defered.resolve([]);
                }
            }, error => {
                defered.reject(error);
            });
        return defered.promise;
    }

    /**
     * @description 产品属性查询特定分类产品--跳转分类产品搜索页面
     * */
    public searchProducts($event?) {
        // 回车键--执行产品搜索
        if ($event && $event.keyCode != 13) {
            return;
        }
        if ($event) {
            $event.preventDefault()
        }
        // 搜索条件不能为空，搜索条件不能为空字符串
        if (angular.isUndefined(this.searchkeywords) || !this.searchkeywords) {
            window.qpAlertPrompt.info("Missing search criteria", "Your input search criteria is empty, please enter an available search criteria.");
            return;
        }
        // 搜索结果页--页面跳转参数
        let urlPath: string = `?keywords=${encodeURIComponent(this.searchkeywords ? this.searchkeywords : "")}`;
        if (!this.$objectTree.currentCatalog || !this.$objectTree.currentCatalog.id) {
            window.qpAlertPrompt.info("", "The classified navigation configuration data is missing.");
            return;
        } else {
            urlPath += `&catalog=${encodeURIComponent(this.$objectTree.currentCatalog.id)}`;
            // 获取sort排序规则（"Recommended"排序规则不做处理）
            if (this.sortType && this.sortType != "PRIORITYSORT") {
                urlPath += `&sort=${encodeURIComponent(this.sortType)}`;
            }
            // 当上下文ObjectTree中存在appTag或appName时,进行产品查询时作为url参数一同传入(appName和appTag记录了CMS发布时的环境信息)
            // if (this.$objectTree.appName) {
            //     urlPath = `${urlPath}&appName=${this.$objectTree.appName}`;
            // }
            // if (this.$objectTree.appTag) {
            //     urlPath = `${urlPath}&appTag=${this.$objectTree.appTag}`;
            // }

            this.$window.location.href = this.pageContext.rootPath + `products/search/${urlPath}`;
        }
    }
    /**
     * @description 产品类目不存在，提示用户再次确认页面地址并刷新页面，或者点击“ok”前往首页
     * */
    private catalogMissingTip() {
        const tipConfig: IMessageDialogOptions = {
            title: this.$translate.instant('CATALOG_NO_FOUND_PAGE_TITLE'),
            content: this.$translate.instant('CATALOG_NO_FOUND_PAGE_CONTENT')
        }
        this.qpMessageDialog.info(tipConfig).then(actionType => {
            if (actionType == "ok") {
                this.$window.location.href = envConfig.getHomePage(this.pageContext.rootPath);
            }
        });

        // TODO 产品类目不存在时，跳转默认类目
        // 产品类目不存在但存在产品类目时，跳转到默认类目
        if (this.$objectTree.defaultCatalogId) {
            this.$window.location.href = `${this.$objectTree.customizePath}${this.$objectTree.defaultCatalogPagePath}` + this.$objectTree.urlParameter;
        } else {
            // 产品类目不存在，且不存在默认类目时，跳转当前产品类目第一项
            this.$window.location.href = `${this.$objectTree.customizePath}${this.$objectTree.defaultCatalogPagePath}` + this.$objectTree.urlParameter;
        }
    }
    /**
     * @description 前往默认产品类目页
     * */
    private goDefaultCatalog() {
        this.$window.location.href = `${this.$objectTree.customizePath}${this.$objectTree.defaultCatalogPagePath}` + this.$objectTree.urlParameter;
    }





    private onCurrencyChange() {
        this.isProductPriceInitializing = true;
        if (!this.$objectTree.currentCatalog || !this.$objectTree.currentCatalog.id) {
            this.isProductPriceInitializing = false;
            return
        }
        // console.log("this.currentPage", this.currentPage);
        let requestQueuePromise: angular.IPromise<CatalogProduct[][]>;
        if (this.currentPage > 1) {
            let requestQueue: angular.IPromise<CatalogProduct[]>[] =
                Array.from({ length: this.currentPage }).map((_, index) => {
                    return this.getCatalogProducts(index + 1, this.limit, this.$objectTree.currentCatalog!.id)
                })
            requestQueuePromise = Promise.all(requestQueue)
        } else {
            // 统一化处理
            let requestQueue: angular.IPromise<CatalogProduct[]>[] = [this.getCatalogProducts(1, this.limit, this.$objectTree.currentCatalog.id)]
            requestQueuePromise = Promise.all(requestQueue)
        }
        requestQueuePromise.then(res => {
            // console.log("this.products.pre", this.products)
            this.products = res.flat(1).map((item, index) => {
                return {
                    ...this.products[index],
                    ...item
                }
            });
            // console.log("this.products", this.products);
        }).catch(error => {
            //关闭骨架屏动画
            this.onRequestFailed(error)
                .then(e => {
                    // 通用错误处理
                    this.openUnhandleErrorMsgDialog();
                    this.sendError('catalog.products.sortProducts()', error);
                })
        }).finally(() => {
            this.$scope.$apply(() => {
                this.isProductPriceInitializing = false;
            })
        })
    }
    private onCurrencyChangeByPostMessage(e: MessageEvent<productCatalogIframeUpdateCurrencyParams['data']>) {
        if (e.data && e.data.type === "UpdateCurrency") {
            this.eventBus.dispatch("UpdateCurrency", {
                code: e.data.data.currencyCode
            });
        }
    }
    public handleMouseEnter($event: ng.IAngularEvent, catalogProduct) {
        // $event.stopPropagation?.();
        // console.log("1")
        // if (catalogProduct.hoverImage) {
        //     catalogProduct.productImage.displayPath = `${this.fileRoot}/file/${catalogProduct.hoverImage.name}?width=250&height=250`
        // }
        catalogProduct.isHover = true;

    }
    public handleMouseLeave($event: ng.IAngularEvent, catalogProduct) {
        // $event.stopPropagation?.();
        // console.log("2")
        // //加一个防抖

        // catalogProduct.productImage.displayPath = `${this.fileRoot}/file/${catalogProduct.productImage.name}?width=250&height=250`
        catalogProduct.isHover = false;

    }

    /**
     * @description 更新页面title
     * @params pageTitle
     * */
    private updatePageTitle(pageTitle: string) {
        if (!is.undefined(pageTitle)) {
            document.title = pageTitle;
        }

    }
    /**
     * @deprecated 2026-5-22 网站发布时动态添加-无需页面动态处理
     * @description 更新页面metaDescription
     * @params pageMetaDes
     * */
    private updatePageMetaDes(metaDes: string) {
        let metaElement = this.getOrCreateMetaElement("name", "description");
        if (!is.undefined(metaDes)) {
            metaElement.setAttribute('content', metaDes);
        }
    }

    /**
     * @description 同步 canonical 链接到当前真实 URL。
     * 类目页使用 AngularJS html5Mode 客户端路由(pushState)切换，<head> 不会重新解析，
     * 首屏 head 中的 IIFE 在路由切换后不再执行，故需在此手动更新，避免 canonical 指向旧 URL。
     * 规则与 head-catalog.ftl 保持一致：仅取 origin + pathname（去掉 query/tracking 参数）。
     * */
    private updateCanonical() {
        let canonicalLink = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
        if (!canonicalLink) {
            canonicalLink = document.createElement('link');
            canonicalLink.setAttribute('rel', 'canonical');
            document.head.appendChild(canonicalLink);
        }
        if (this.$window.location) {
            canonicalLink.setAttribute('href', this.$window.location.origin + this.$window.location.pathname);
        }
    }

    /**
     * @description 获取或创建指定meta标签元素
     * @param type 
     * @param key
     * */

    // 辅助函数：根据 type 和 key 获取或创建 meta 标签 (保证存在)
    private getOrCreateMetaElement(type: "name" | "property", key: string) {
        let selector = '';
        if (type === 'name') {
            selector = `meta[name="${key}"]`;
        } else if (type === 'property') {
            selector = `meta[property="${key}"]`;
        } else {
            throw new Error('不支持的 meta 类型');
        }
        let meta = document.querySelector(selector);
        if (!meta) {
            meta = document.createElement('meta');
            if (type === 'name') {
                meta.setAttribute('name', key);
            } else {
                meta.setAttribute('property', key);
            }
            // 设置一个默认初始值避免空白
            meta.setAttribute('content', '');
            document.head.appendChild(meta);
        }
        return meta;
    }
}